import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaRegClock, FaEnvelopeOpenText } from 'react-icons/fa';
import FinancingExceptionPage from 'Modules/fortiva/components/FinancingExceptionPage';

export default function FinancingDecisionPending() {
  const { t } = useTranslation();

  return (
    <FinancingExceptionPage
      pageTitle={t('fortiva.decisionPending.pageTitle', 'Payment Portal - Application Pending')}
      icon={FaRegClock}
      testId="title-decision-pending"
      gradientStyle="linear-gradient(to right, rgb(218, 97, 56), rgb(126, 68, 125))"
      subtitleColorClass="text-orange-50"
      title={t('fortiva.decisionPending.title', 'A little more information is needed')}
      subtitle={t(
        'fortiva.decisionPending.subtitle',
        'We need some additional details to continue processing your application.'
      )}
      description={
        <>
          <p className="text-gray-900 text-xl font-medium mb-3">
            {t(
              'fortiva.decisionPending.lead',
              'Thank you for getting started with your application.'
            )}
          </p>
          <p className="text-base">
            {t(
              'fortiva.decisionPending.description',
              'However, we need a few additional details from you before we can process it.'
            )}
          </p>
        </>
      }
      infoCard={{
        icon: FaEnvelopeOpenText,
        iconBgColor: 'bg-sky-50',
        iconColor: 'text-sky-600',
        title: t('fortiva.decisionPending.emailTitle', 'Check your email to continue'),
        description: t(
          'fortiva.decisionPending.emailDescription',
          'Open the email we just sent and follow the detailed instructions to provide the information we need and complete your application.'
        ),
      }}
    />
  );
}
